import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Context } from "../../../contexts/Store";

export default function SessionRoute({ children }) {
  const location = useLocation();
  const { state } = useContext(Context);
  const auth = state.user_details?.is_login;

  if (auth) return children;
  const next = location.pathname !== "/" ? location.pathname : "";
  const search = next ? `?auth=login&next=${encodeURIComponent(next)}` : "?auth=login";
  return <Navigate to={next ? `/?auth=login&next=${encodeURIComponent(next)}` : "/?auth=login"} replace />;
}
